module.exports = __webpack_public_path__ + "static/src/content/logos/spotify.9d0ed4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/logos/spotify.png
// module id = MwLh
// module chunks = 1